import { Document, Image, Page, PDFViewer, Text, View } from "@react-pdf/renderer";
import moment from "moment";

export const SchoolStudentDashboardActivityReport = ({ data, context }) => {

    const headers = [
        { id: 'name', text: 'Atividade', width: '33%' },
        { id: 'teachers', text: 'Professores', width: '25%' },
        { id: 'class.name', text: 'Turma', width: '20%' },
        // { id: 'class.academic_period.name', text: 'Período letivo', width: '10%' },
        { id: 'start_at', text: 'Início', width: '10%' },
        { id: 'end_at', text: 'Término', width: '10%' }
    ]

    const translate_value = (val) => {
        switch (val) {
            default:
            case null:
                return 'Todas';
            case true:
                return 'Finalizadas';
            case false:
                return 'Em aberto';
        }
        return ''
    }

    return (
        <PDFViewer width='100%' height='600px'>
            <Document language="pt-BR" author="Juristta" title="relatorio_atividades_juristta.pdf">
                <Page orientation="portrait" size={"A4"} style={{ padding: '16px' }}>
                    {/* Título */}
                    <View style={{ flexDirection: 'row', marginBottom: '16px' }}>
                        <View style={{ alignSelf: 'center', paddingRight: '10px', borderRight: '1px solid black' }}>
                            <Image src={{
                                uri: 'https://game-juridico.s3.sa-east-1.amazonaws.com/assets/LOGO_JURISTTASCHOOL_PRETO.png',
                                headers: { 'Cache-Control': 'no-cache' },
                                method: 'GET',
                            }} style={{ width: '136px', height: '32px', borderRadius: '4px' }}></Image>
                        </View>
                        <View style={{ paddingLeft: '10px' }}>
                            <Text style={{ fontWeight: 'bold', fontFamily: 'Helvetica-Bold' }}>{`Relatório de atividades`}</Text>
                            <Text style={{ fontSize: 14 }}>{`Resumo das atividades realizadas`}</Text>
                        </View>
                    </View>
                    {/* Cabeçalho */}
                    <View style={{
                        padding: '8px',
                        border: '1px solid gray',
                        borderRadius: '8px',
                        flexDirection: 'row',
                        fontSize: '10px',
                        marginBottom: '16px'
                    }}>
                        <View>
                            <Text style={{ fontSize: '12', fontWeight: 'bold', fontFamily: 'Helvetica-Bold' }}>Nome</Text>
                            <Text>{context.currentUser.name}</Text>
                        </View>
                        <View style={{ flexGrow: 1 }}></View>
                        <View style={{ marginHorizontal: '4px' }}>
                            <Text style={{ fontSize: '12', fontWeight: 'bold', fontFamily: 'Helvetica-Bold' }}>Instituição</Text>
                            <Text>{context?.institutionBranch.institution.name || 'Todos'}</Text>
                        </View>
                        <View style={{ marginHorizontal: '4px' }}>
                            <Text style={{ fontSize: '12', fontWeight: 'bold', fontFamily: 'Helvetica-Bold' }}>Unidade</Text>
                            <Text>{context.institutionBranch.name || 'Todos'}</Text>
                        </View>
                        <View style={{ marginHorizontal: '4px' }}>
                            <Text style={{ fontSize: '12', fontWeight: 'bold', fontFamily: 'Helvetica-Bold' }}>Período letivo</Text>
                            <Text>{data?.academicPeriod?.name || 'Todos'}</Text>
                        </View>
                    </View>
                    {/* Tabela */}
                    <View style={{ flexGrow: 1 }}>
                        {/* Headers */}
                        <View style={{
                            backgroundColor: '#1e466f',
                            color: 'white',
                            flexDirection: 'row',
                            fontSize: 12,
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            paddingHorizontal: '2%',
                            paddingVertical: '4px',
                        }}>
                            {
                                headers?.map(
                                    (header, idx) => (
                                        <View
                                            key={`${header.id}-${idx}`}
                                            style={{
                                                width: header.width,
                                                alignSelf: 'center',
                                                marginRight: '4px',
                                            }}
                                        >
                                            <Text>{header.text}</Text>
                                        </View>
                                    )
                                )
                            }
                        </View>
                        {/* Dados */}
                        <View
                            style={{ fontSize: 10, border: '1px solid lightgray' }}
                        >
                            {
                                data.data && data?.data.map(
                                    (row) => (
                                        <View style={{
                                            flexDirection: 'row',
                                            borderBottom: '1px solid lightgray',
                                            paddingVertical: '2px',
                                            paddingHorizontal: '2%',
                                        }}>
                                            <View style={{ width: '33%', marginRight: '4px', alignSelf: 'center' }}><Text>{row.name}</Text></View>
                                            <View style={{ width: '25%', marginRight: '4px', alignSelf: 'center' }}>{row.teachers.map((item) => <Text>{item.user.name}</Text>)}</View>
                                            <View style={{ width: '20%', marginRight: '4px', alignSelf: 'center' }}><Text>{row.class.name}</Text></View>
                                            {/* <View style={{ width: '10%', marginRight: '4px', alignSelf: 'center' }}><Text>{row.class.academic_period.name}</Text></View> */}
                                            <View style={{ width: '10%', marginRight: '4px', alignSelf: 'center' }}><Text>{moment(row.start_date).format('DD/MM/YYYY')}</Text></View>
                                            <View style={{ width: '10%', marginRight: '4px', alignSelf: 'center' }}><Text>{moment(row.end_date).format('DD/MM/YYYY')}</Text></View>
                                        </View>
                                    )
                                )
                            }
                        </View>
                    </View>
                    {/* Rodapé */}
                    <View style={{ borderTop: '1px solid lightgray', textAlign: 'right', justifySelf: 'flex-end', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <Text style={{ fontSize: '8', paddingTop: '8px' }}>{`Juristta School`}</Text>
                        <Text style={{ fontSize: '8', paddingTop: '8px' }}>{`Emitido em ${new Date().toLocaleString()}`}</Text>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    )
}